import { createSelector } from 'reselect';
import { isLoadingSelector, requestStatusMessageSelector, requestStatusSelector } from './selectors';

/**
 * Memoized selector that aggregates user form request status, status message, and loading state.
 *
 * Combines the current request status, request status message, and loading boolean for convenient access in user form components.
 *
 * @function
 * @returns {Object} An object containing:
 *   @property {string|undefined} requestStatus - The current status of the request (e.g., "success", "error", etc.).
 *   @property {string|undefined} requestStatusMessage - A message associated with the request status.
 *   @property {boolean|undefined} isLoading - Whether the user form is in a loading state.
 *
 * @example
 * const { requestStatus, requestStatusMessage, isLoading } = useSelector(userFormSelector);
 */
export const userFormSelector = createSelector(
    [requestStatusSelector, requestStatusMessageSelector, isLoadingSelector],
    (requestStatus, requestStatusMessage, isLoading) => ({
        requestStatus,
        requestStatusMessage,
        isLoading,
    }),
);
